import { UserRolePermissions } from '../../constants';
import { checkSitePermission } from '../../store/slices/user';

const checkDoChargeAgencyPlanningFees = (tripId) => (store) => {
  let canCharge = checkSitePermission(UserRolePermissions.canChargeAgencyPlanningFees)(store);
  if (store.user.travelAgency
    && (store.user.travelAgency.chargeAgencyFeesForTravelType === undefined
    || store.user.travelAgency.chargeAgencyFeesForTravelType === null)) {
    return canCharge;
  }
  const trip = store.trip && store.trip.selectedTrips && store.trip.selectedTrips[tripId];
  if (canCharge && trip && trip.bookedTravelTypes
      && store.user.travelAgency
      && store.user.travelAgency.chargeAgencyFeesForTravelType !== null
      && store.user.travelAgency.chargeAgencyFeesForTravelType !== undefined
      && trip.bookedTravelTypes.indexOf(
        store.user.travelAgency.chargeAgencyFeesForTravelType,
      ) === -1) {
    canCharge = false;
  }
  return canCharge;
};

export default checkDoChargeAgencyPlanningFees;
